
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">404</h1>
            <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
            <a href="/" className="text-blue-500 hover:text-blue-700 underline">
              Return to Home
            </a>
          </div>
        </div>
      </div>

      {/* Powered by text */}
      <div className="absolute bottom-4 right-8 text-white/80 text-sm">
        Powered by <a 
          href="http://whatstudio.co.uk/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="font-bold hover:text-white transition-colors"
        >
          WHATS Studio
        </a>
      </div>
    </Layout>
  );
};

export default NotFound;
